export const IS_PROD_URL =
  window.location.host.indexOf('app.mobilemonkey.com') > -1;
